import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fade from '@mui/material/Fade';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import './../assets/template/css/style-starter.css'
import { Link } from 'react-router-dom';

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}



const Header = (props: Props) => {
    // const { window } = props;
    const currentPath = window.location.pathname;

    console.log("currentPath", currentPath);


    return (
        <div className="header-w3l">
            <header id="site-header" className="fixed-top">
                <div className="container">
                    <nav className="navbar navbar-expand-lg stroke">
                        <Link className="navbar-brand pr-lg-5" to="/">
                            <img src="/assets/images/logo1.png" alt="" className="img-fluid" />
                        </Link>

                        <button className="navbar-toggler  collapsed bg-gradient" type="button" data-toggle="collapse"
                            data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon fa icon-expand fa-bars"></span>
                            <span className="navbar-toggler-icon fa icon-close fa-times"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                            <ul className="navbar-nav mr-lg-auto">
                                <li className={"nav-item" + (currentPath === '/' ? ' active' : '')}>
                                    <Link className="nav-link" to="/">首页</Link>
                                </li>
                                <li className={"nav-item" + (currentPath.includes('lesson') ? ' active' : '')}>
                                    <Link className="nav-link" to="/lesson">课程体系</Link>
                                </li>

                                <li className={"nav-item" + (currentPath.includes('contact') ? ' active' : '')}>
                                    <Link className="nav-link" to="/contact">联系我们</Link>
                                </li>
                            </ul>
                            <ul className="navbar-nav search-right mt-lg-0 mt-2">
                                <li className="mx-3">
                                    <Link to="/contact" className="btn btn-style btn-primary">现在报名</Link>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
        </div>
    );
}

export default Header;